import React, { useEffect,useRef,useState } from 'react'
import PropTypes from 'prop-types'
import PaymentModal from './test'
import axios from 'axios'
import { Config } from './Component/Common/Config'

const Test2Pyment = props => {
    const [secrectkey, setsecrectkey] = useState(null)
    const hasFetched = useRef(false);
    useEffect(() => {
        if (!hasFetched.current) {
        getkey()
        hasFetched.current = true;
        }
    }, [])
    const getkey = async () => {
        let url = `https://api.ldcbe.webdezign.uk/api/v1/stripe/payment-intent`
        const response = await axios.post(url, {
            "amount": 1000,
            "currency": "gbp"
        }, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            }
        });
        console.log(':::response',response.data)
        setsecrectkey(response.data.clientSecret)
    }

    return (
        <>
            {secrectkey == null ? <div>Test2Pyment</div> : <PaymentModal clientSecret={secrectkey} />}
        </>
    )
}

Test2Pyment.propTypes = {}

export default Test2Pyment